var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{class:`cursor-pointer ${_vm.setting['icon']} btn-tooltip text-${_vm.setting['color']}`,attrs:{"data-bs-toggle":"tooltip","data-bs-placement":"top","data-container":"body","data-animation":"true","title":_vm.tooltip},on:{"click":_vm.click}})
}
var staticRenderFns = []

export { render, staticRenderFns }